import domReady from '@wordpress/dom-ready';

domReady( () => {
	const socialsShareBlock = document.querySelector(
		'.wp-block-do-blocks-social-share'
	);
	if ( socialsShareBlock ) {
		const moreShareButton = socialsShareBlock.querySelector(
			'.social-share-item-more'
		);
		moreShareButton.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			socialsShareBlock.classList.toggle( 'is-open' );
		} );
	}
} );
